<div *ngIf="errorMessage" class="alert alert-danger alert-dismissable">
  <strong>Erro ao buscar ficha: </strong> {{errorMessage}}
</div>

<app-central-loader [show]="isGettingFicha && !errorMessage" text="Obtendo Ficha Proposta..."></app-central-loader>

<div role="tabpanel" class="tab-pane " id="formD" *ngIf="!isGettingFicha && !errorMessage">
  <div class="resultado-parcial__header">
    <span>Resultado Parcial
      <span class="fa fa-spinner fa-pulse" aria-hidden="true" *ngIf="isExecutandoSimulacao"></span>
    </span>

    <seguro
      *ngIf="isEtapa"
      [grupoAssistenciaIds]="simulacao.seguro.gruposAssistenciaIds[0]"
      [grupoSeguroIds]="simulacao.seguro.gruposSeguroIds"
      [retornoMax]="proposta.taxaCliente.retornoMax"
      [retorno]="simulacao.seguro.retorno"
      [proposta]="proposta.id"
      [gruposSeguros]="proposta.gruposSeguros"
      [gruposAssistencias]="proposta.gruposAssistencias"
      [tipoVeiculo]="getTipoVeiculo()"
      [isVeiculoPrincipal]="true"
      [indexGarantia]="0"
      (seguroSelected)="onChangeSeguro($event)">
    </seguro>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class="panel blue">
        <span class="icon"></span>
      </div>

      <veiculo
        *ngFor="let veiculo of proposta.veiculos; let i = index"
        [fichaCadastro]="fichaCadastro"
        [veiculo]="(veiculo || {})"
        [numeroVeiculo]="i+1"
        [proposta]="proposta"
        (veiculoAlterar)="onUpdateVeiculo()">
        <seguro
          *ngIf="i !== 0"
          [grupoAssistenciaIds]="simulacao.seguro.gruposAssistenciaIds[i]"
          [grupoSeguroIds]="simulacao.seguro.gruposSeguroIds"
          [retornoMax]="proposta.taxaCliente.retornoMax"
          [retorno]="simulacao.seguro.retorno"
          [gruposSeguros]="proposta.gruposSeguros"
          [gruposAssistencias]="proposta.gruposAssistencias"
          [tipoVeiculo]="veiculo.grupo2"
          [indexGarantia]="i"
          (seguroSelected)="onChangeAssistencia($event, i)">
        </seguro>
      </veiculo>

      <app-valor-financiado
        [disabled]="isExecutandoSimulacao"
        [cotacao]="getCotacao()"
        [valorSimular]="simulacao.valor"
        (valorSimularChange)="onChangeValorSimular($event)">
      </app-valor-financiado>

      <parcela *ngIf="!pagamentoFlexivel"
        [proposta]="proposta"
        [simulacao]="simulacao"
        [parcelasSimuladas]="parcelasSimuladas"
        (simular)="onChangeParcela($event)"
        (parcelaSelecionadaChange)="onParcelaSelecionada($event)">
      </parcela>

      <parcela-flexivel *ngIf="pagamentoFlexivel"
        [proposta]="proposta"
        [simulacao]="simulacao"
        [parcelasSimuladas]="parcelasSimuladas"
        [parametros]="parametros"
        (simular)="onChangeParcela($event)"
        (parcelaSelecionadaChange)="onParcelaSelecionada($event)">
      </parcela-flexivel>
      
    </div>
  </div>
  <div class="row">
    <div class="marginT30 clean-panel tab-buttons">
      <a (click)="onClickNext()" class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': isButtonNextDisabled || isExecutandoSimulacao}">Continuar <i class="fa fa-arrow-right mlBt"></i></a>
    </div>
  </div>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'" [hideClose]="true"></app-modal-message>

<app-modal-message #modelAttentionMessage [title]="'Atenção!'" [hideClose]="false" [labelOk]="'Continuar'" [labelClose]="'Voltar'" (ok)="onReturnContinueAttentionMessageZeroStar()"></app-modal-message>

<app-new-modal-message #messageModal [showFecharBtn]="false"></app-new-modal-message>
